import React from "react";
import { IconButton, Grid } from "@material-ui/core";
import FilterIcon from "@material-ui/icons/FilterListOutlined";
import { DisplayDrawerContext } from "../../../../layout/DisplayDrawerContext";
import { useWeightPriceReportFilter } from "../../../../data/reports/exchbusiness/weightedPrices/hooks/useWeightedPriceReportFilter";
import { LocalizationContext } from "../../../../core/localization/Localization";
import { CustomTooltip } from "../../../components/common/CustomTooltip";
import { WeightedPricesFilterEditor } from "./WeightedPricesFilterEditor";

export const WeightedPricesReportFilter: React.FunctionComponent = () => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  const showFilter = React.useCallback(
    () => showWithDrawer(<WeightedPricesFiltersEditor />),
    [showWithDrawer]
  );

  const [filter, editfilter, save] = useWeightPriceReportFilter();
  const { getString } = React.useContext(LocalizationContext);

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <CustomTooltip titleKeyword="filterTooltip">
          <IconButton color="secondary" component="span" onClick={showFilter}>
            <FilterIcon />
          </IconButton>
        </CustomTooltip>
      </Grid>
    </Grid>
  );
};

const WeightedPricesFiltersEditor: React.FunctionComponent = () => {
  const [filter, editFilter, save] = useWeightPriceReportFilter();
  return (
    <WeightedPricesFilterEditor
      filter={filter}
      editFilter={editFilter}
      save={save}
    />
  );
};
